function Loader() {
  return (
    <div className="loading-area">
      <div className="loading-box"></div>
      <div className="loading-pic">
        <div className="loader logo-loader logo-loader-image">
          <img src="/neurologo.png" alt="Neuron logo" className="loader-logo-image" />
          <div className="loader-logo-text">
            <span className="loader-logo-main">NEURON</span>
            <span className="loader-logo-tagline">Consultancy Kenya</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Loader;
